export function getSplitUnitLabel(orderItem) {
  return (
    orderItem?.selling_unit_of_measure || orderItem?.unit_of_measure || "units"
  );
}

export function sumSplitQuantities(splits = [], excludeId = null) {
  return Number(
    splits
      .filter((split) => split.id !== excludeId)
      .reduce((total, split) => total + Number(split.quantity || 0), 0)
      .toFixed(4),
  );
}

export function getSplitRemainder(orderItem, excludeId = null) {
  const quantity = Number(
    orderItem?.shipment_order_item?.shipped_quantity ??
      orderItem?.shipped_amount ??
      orderItem?.quantity ??
      0,
  );
  return Number(
    Math.max(
      0,
      quantity - sumSplitQuantities(orderItem?.price_splits, excludeId),
    ).toFixed(4),
  );
}

export function buildPriceSplitPayload(values) {
  return {
    quantity: Number(values.quantity),
    unit_price: Number(values.unit_price),
  };
}
